import React, { Component } from 'react';
import '../config/global';

class CTBannerDetail extends Component {
    constructor (props) {
        super(props);
        this.state = {
            activelink:"none",
            stTitle: '',
            banner_id: '',
            banner_type: '',
            banner_number: '',
            banner_filename: '',
            banner_filetype: '',
            banner_fileurl: '',
            banner_linkurl: '',
            banner_targeturl: '',
            banner_language: '',
            banner_status: '',
        }
    }

    componentDidMount() {
        document.getElementById('loading-area').style.display = 'block'; 
        var othersContent = JSON.parse(document.getElementById("contentoth").innerText);
        this.setState({
            banner_id: othersContent.banner_id,
            banner_type: othersContent.banner_type,
            banner_number: othersContent.banner_number,
            banner_language: othersContent.banner_language,
            banner_status: othersContent.banner_status,
            banner_filename: othersContent.banner_filename,
            banner_filetype: othersContent.banner_filetype,
            banner_fileurl: othersContent.banner_fileurl,
            banner_linkurl: othersContent.banner_linkurl,
            banner_targeturl: othersContent.banner_targeturl,
        }); 
    }

    render() {
        return (
            <div className="container">
               <div className="row show">
                    <h5>{this.state.stTitle} #{this.state.banner_number}</h5>
                    <div className="fieldComments">
                        <label>Position in : Homepage {this.state.banner_type}</label>
                        <label className="ms-3">for {this.state.banner_language} version</label><br/>
                        <label>Status : {this.state.banner_status}</label>
                    </div>
                </div>
                <div className="row mt-3">
                    
                    <div className="row mt-3">
                        <a href={this.state.banner_linkurl} target="_blank" noreferrer><img src={this.state.banner_fileurl} border="0" width="500" /></a>
                    </div>
                    <div className="mt-3"><label className="fw-bold">File Name : {this.state.banner_filename}</label></div>
                    <div className="mt-3">
                        Destination Link Banner : {this.state.banner_linkurl}<br/>
                        Target Link Banner : {this.state.banner_targeturl === "_self"? "Same window" : "open to new tab/window"}
                    </div>
                    <div className="row mb-3"></div>

                </div>
            </div>
          );
        }
     }
      
export default CTBannerDetail;
